// extracted by mini-css-extract-plugin
module.exports = {"container":"PureModal_container__hrQ2R","wrapper":"PureModal_wrapper__1Mq-O","content":"PureModal_content__1yVsN","closeIcon":"PureModal_closeIcon__3aHzt"};